// ===================================================
// WHISKEY THING RETRIEVE DATA
// ===================================================

$(window).load(function(){
  $('.exp__dd-btn').click(function() {
    $('.exp__quant-add-button').trigger('click');
  });
  $('.exp__quant-add-button').trigger('click');
});

function calculateMinHeightNew(){
	var infoWrapper 		= $('.Product__Info').outerHeight();
  	$('.Product__Wrapper').css('min-height', infoWrapper + 'px');
}

var wTcustomerData;

$('.custom-whiskey #customerList').hide();

$.get( "https://sheets.googleapis.com/v4/spreadsheets/17vf97EkptTz94m-ui23jaUJ5HtW1cMYh9lQ6OmFkpKs/values/Sheet?key=AIzaSyDWNw9SrvtpFPlLo3gXi6_PN06n7zxEIGc",  function( data ) {
    wTcustomerData = data;
    $('.custom-whiskey #customerList').show();
    $('.custom-whiskey #loading').hide();
});

$('.custom-whiskey #customerList').submit(function(e){
    e.preventDefault();
    wTdisplayCustomer($('.custom-whiskey #customerSelect').val());
    calculateMinHeightNew();
});

$('#landingRecipe').submit(function(e){
    e.preventDefault();
    wTstoreCustomer($('.custom-whiskey #customerSelect').val());
    Cookies.set('tried-form', true);
    location.href = "https://the-distillery-london.myshopify.com/products/bespoke-recipe-whiskey-thing-blend-re-orders";
});

function wTstoreCustomer(wTcode){
   
    var wTuniqueNumber = Cookies.get('wTuniqueNumber');  // Unique Number
    var wTdateVisited = Cookies.get('wTdateVisited');    // Date Visited
    var wTfirstName = Cookies.get('wTfirstName');        // First Name
    var wTlastName = Cookies.get('wTlastName');          // Last Name

    for(i=0;i<wTcustomerData.values.length;i++){
        var wTcustomer = wTcustomerData.values[i];
        
        if(wTcustomer[1] == wTcode){
            Cookies.set('wTuniqueNumber', wTcustomer[1]);  // Unique Number
            Cookies.set('wTdateVisited',  wTcustomer[2]);  // Date Visited
            Cookies.set('wTfirstName',    wTcustomer[3]);  // First Name
            Cookies.set('wTlastName',     wTcustomer[4]);  // Last Name
        }
    }
}

function wTdisplayCustomer(wTcode){
    
    $('.ingredients').remove();
    $('#infiniteoptions-container').html('<div id="infiniteoptions-container"><div><label for="Name-0-0" class="spb-productdescfont spb-productdesctextcolor">Name</label><span><input type="text" name="properties[Name]" id="Name-0-0" class="spb-productdescfont spb-productoptiontextcolor spb-productoptionbackground"></span></div><div><label for="Date Created-0-1" class="spb-productdescfont spb-productdesctextcolor">Date Created</label><span><input type="text" name="properties[Date Created]" id="Date Created-0-1" class="spb-productdescfont spb-productoptiontextcolor spb-productoptionbackground"></span></div><div><label for="Recipe Code-0-19" class="spb-productdescfont spb-productdesctextcolor">Recipe Code</label><span><input type="text" name="properties[Recipe Code]" id="Recipe Code-0-19" class="spb-productdescfont spb-productoptiontextcolor spb-productoptionbackground" required=""></span></div></div>')
    $('#infiniteoptions-container').after('<div class="ingredients white pad-xs-30" id="not-found"><h5>Sorry, your number wasn’t recognised or is still being processed.</h5><p> Please email <a href="mailto:info@theginstitute.com">info@theginstitute.com</a> and we’ll be happy to handle your order directly.</div>');

  for(i=0;i<wTcustomerData.values.length;i++) {
    var wTcustomer = wTcustomerData.values[i];
 
    if(wTcustomer[1] == wTcode){
      
      var wTuniqueNumber  = wTcustomer[1]; // Unique Blend Number
      var wTdateVisited   = wTcustomer[2]; // Date Visited          
      var wTfirstName     = wTcustomer[3]; // First Name
      var wTlastName      = wTcustomer[4]; // Last Name

      $('.ingredients').remove();
      $('#infiniteoptions-container').after('<div class="ingredients gold pad-xs-30"><div id="ingredients-name"></div><div id="ingredients-details"></div></div>');
      $('#ingredients').find('p').remove();
      $('#ingredients-name').append('<h4 class="unique-no">' + wTuniqueNumber + '</h4>');
      $('[name="properties[Name]"]').val(wTfirstName + ' ' + wTlastName);
      $('#ingredients-name').append('<h5 class="blended-name">' + wTfirstName + ' ' + wTlastName + '</h5>');
      $('[name="properties[Date Created]"]').val(wTdateVisited);
      $('#ingredients-name').append('<h5 class="blended-on">Blended on – ' + wTdateVisited + '</h5>');
      $('[name="properties[Recipe Code]"]').val(wTuniqueNumber);

      $('#display-ingredients').show();
      $('form.ProductForm').removeClass('customProduct');
      
    }
}
}


$(window).load(function() {
if (Cookies.get('wTfirstName')) {

  var wTuniqueNumber = Cookies.get('wTuniqueNumber');  // Unique Number
  var wTdateVisited = Cookies.get('wTdateVisited');    // Date Visited
  var wTfirstName = Cookies.get('wTfirstName');        // First Name
  var wTlastName = Cookies.get('wTlastName');          // Last Name

  setTimeout(function(){

      $('[name="properties[Name]"]').val(wTfirstName + ' ' + wTlastName);
      $('[name="properties[Date Created]"]').val(wTdateVisited);
      $('[name="properties[Recipe Code]"]').val(wTuniqueNumber);

      $('.ingredients').remove();
      $('#infiniteoptions-container').after('<div class="ingredients gold pad-xs-30"><div id="ingredients-name"></div><div id="ingredients-details"></div></div>');
      $('#ingredients').find('p').remove();
      $('#ingredients-name').append('<h4 class="unique-no">' + wTuniqueNumber + '</h4>');
      $('[name="properties[Name]"]').val(wTfirstName + ' ' + wTlastName);
      $('#ingredients-name').append('<h5 class="blended-name">' + wTfirstName + ' ' + wTlastName + '</h5>');
      $('[name="properties[Date Created]"]').val(wTdateVisited);
      $('#ingredients-name').append('<h5 class="blended-on">Blended on – ' + wTdateVisited + '</h5>');

  },1000);
  
  Cookies.remove('wTuniqueNumber');  // Unique Number
  Cookies.remove('wTdateVisited');   // Date Visited
  Cookies.remove('wTfirstName');     // First Name
  Cookies.remove('wTlastName');      // Last Name

} else {
  if (Cookies.get('tried-form', true)) {
    $('.ingredients').remove();
    $('#infiniteoptions-container').after('<div class="ingredients white pad-xs-30" id="not-found"><h5>Sorry, Your number wasn’t recognised or is still being processed.</h5><p> Please email <a href="mailto:info@theginstitute.com">info@theginstitute.com</a> and we’ll be happy to handle your order directly.</div></div>');
  }
}
});